var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVehicleInspection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    height: "2.22rem",
    width: "2.22rem",
    alt: "Vehicle Inspection Icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vehicle__Inspection",
    "data-name": "Vehicle_Inspection"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.15,36.87a2,2,0,0,0-1.88-.69L33.1,33.61a10,10,0,1,0-1.33,1.5l2,2.35a2,2,0,0,0,.33,1.93l8,9.77a2,2,0,1,0,3.07-2.51ZM25,35.78a8,8,0,1,1,8-8A8,8,0,0,1,25,35.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.58,9.29a1,1,0,0,0-.89-.61H44.14a1,1,0,0,0-.89.61,6.13,6.13,0,0,0-.32,1.26L38.71,2.4a1.81,1.81,0,0,0-1.38-1.17,68.43,68.43,0,0,0-24.66,0A1.81,1.81,0,0,0,11.29,2.4L7.07,10.55a6.13,6.13,0,0,0-.32-1.26,1,1,0,0,0-.89-.61H1.31a1,1,0,0,0-.89.61,4.51,4.51,0,0,0,0,3.46,1,1,0,0,0,.89.61H5.86a1,1,0,0,0,0,.17,2.34,2.34,0,0,0-1.66,2.24V31.2a1.12,1.12,0,0,0,1.12,1.12H11A1.12,1.12,0,0,0,12.1,31.2V28.49H13l0-.06c0-.22,0-.45,0-.68a11.93,11.93,0,0,1,2.53-7.35H8.85V17.23h6.86L16.84,19a11.92,11.92,0,0,1,16.32,0l1.13-1.76h6.86V20.4h-6.7A11.88,11.88,0,0,1,37,27.75c0,.23,0,.45,0,.68l0,.06h.92V31.2A1.12,1.12,0,0,0,39,32.32h5.65a1.12,1.12,0,0,0,1.12-1.12V15.77a2.34,2.34,0,0,0-1.66-2.24,1,1,0,0,0,0-.17h4.55a1,1,0,0,0,.89-.61A4.51,4.51,0,0,0,49.58,9.29ZM9.81,13.36l4-9.64S16.51,3,25,3s11.2.69,11.2.69l4,9.64Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleInspection);
export default __webpack_public_path__ + "static/media/VehicleInspection.a3c12e40.svg";
export { ForwardRef as ReactComponent };